import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './MakeupType.module.sass';
import Button from '../../../../ui_kit/button/Button';
import BackButton from '../../back_button/BackButton';
import MAKEUP_PRODUCT_TYPES from '../../../constants/makeup_product_types';
import TypeBlock from './type_block/TypeBlock';
import MAKEUP_CATEGORIES from '../../../constants/makeup_categories';

function MakeupType(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const area = quiz.productType.split(' - ')[0];

  const detailedProductType = quiz.productType.split(' - ').slice(1).join(' - ');

  const types = MAKEUP_PRODUCT_TYPES[
    Object.values(MAKEUP_CATEGORIES).includes(area) ? area : MAKEUP_CATEGORIES.ACCESSORY
  ];

  const [customType, setCustomType] = useState(
    !types.includes(detailedProductType) ? detailedProductType : '',
  );

  const [type, setType] = useState(detailedProductType);

  const productType = `${area} - ${type}`;

  const onNextClick = () => {
    increaseStep({ ...quiz, productType });
  };

  const onCustomTypeChange = (updatedType) => {
    setCustomType(updatedType);
    setType(updatedType);
  };

  const { color } = quiz;

  const title = () => {
    switch (area) {
      case MAKEUP_CATEGORIES.EYES:
        return 'Which product for the eye do you want to beautify?';
      case MAKEUP_CATEGORIES.LIPS:
        return 'Which type of lip product do you want to elevate?s';
      case MAKEUP_CATEGORIES.FACE:
        return 'Which product for complexion is the focus of your attention?';
      case MAKEUP_CATEGORIES.NAILS:
        return 'Which product for nails does your idea entail?';
      case MAKEUP_CATEGORIES.ACCESSORY:
        return 'Which type of accessory is your new necessary?';
      default:
        return 'Which type of accessory is your new necessary?';
    }
  };

  return (
    <>
      <BackButton decreaseStep={() => { decreaseStep({ ...quiz, productType }); }} />
      <div className={styles['makeup-type']}>
        <div className={styles.content}>
          {step}
          <h1 className={styles.title}>
            {title()}
          </h1>
          <div className={styles.description}>
            Select the best option or type other.
          </div>
          <div className={styles.types}>
            {types.map((typeText) => (
              <TypeBlock
                onClick={() => { setType(typeText); }}
                key={typeText}
                text={typeText}
                isActive={type === typeText}
                color={color}
              />
            ))}
            <TypeBlock
              onChange={onCustomTypeChange}
              onClick={() => { setType(customType); }}
              text={customType}
              isActive={type ? type === customType : false}
              color={color}
              editable
            />
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={!type}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

MakeupType.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    productType: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default MakeupType;
